import { render, staticRenderFns } from "./room-plan.vue?vue&type=template&id=789b2ec0&scoped=true&"
import script from "./room-plan.vue?vue&type=script&lang=ts&"
export * from "./room-plan.vue?vue&type=script&lang=ts&"
import style0 from "./room-plan.vue?vue&type=style&index=0&id=789b2ec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b2ec0",
  null
  
)

export default component.exports